import React, { PropsWithChildren } from 'react';
import { TbCircleCheckFilled, TbCreditCard, TbCreditCardPay, TbDots, TbPencil, TbPhotoX } from 'react-icons/tb';
import Img from '../Layout/Img';
import Badge from '../Layout/Badge';
import { useTranslation } from 'react-i18next';
import Button from './Button';

interface ButtonPaymentPropsMethod {
    onClick: CallableFunction;
    disabled?: boolean;
    className?: string;
    payCard?: boolean;
    add?: boolean;
    active?: boolean;
    image_url?: string;
    icon?: any;
    label: string;
    title: string;
    number?: string;
    loading?: boolean;
    main?: boolean;
    editButton?: boolean;
}

const ButtonPaymentMethod = ({
    children,
    onClick = () => {},
    disabled = false,
    className,
    payCard = false,
    add = false,
    active = false,
    image_url,
    icon,
    label,
    title,
    number,
    loading,
    main = false,
    editButton = false
    }: PropsWithChildren<ButtonPaymentPropsMethod>) => {

    const { t } = useTranslation();
    const handleClick = () => {
    onClick();
    }

    return (
        loading
            ?
                <div className="flex items-center gap-2 flex-1 p-3 rounded-lg ring-1 ring-gray-100 animate-pulse">
                    <div className="flex">
                        <div className="self-start flex bg-gray-200 w-7 h-7 rounded-full"></div>
                    </div>
                    <div className="flex flex-col gap-1 w-full">
                        <div className="flex flex-col w-1/4 bg-gray-200 h-2 rounded-md"></div>
                        <div className="flex flex-col w-1/2 bg-gray-200 h-3 rounded-md"></div>
                    </div>
                </div>
            :
                <button
                    type="button"
                    onClick={handleClick}
                    disabled={disabled}
                    className={`
                    ${className}
                    relative flex rounded-md p-4 min-h-18 w-full items-center
                    ${active && !add ? 'hover:shadow-md hover:shadow-gray-100 bg-white ring-2 ring-custom-primary pointer-events-none' : 'active:ring-1 ring-gray-300'}
                    ${add ? `ring-none border-2 border-dashed active:ring-0 ${active ? 'border-custom-primary' : 'border-gray-300 active:border-gray-400'}` : 'hover:shadow-md hover:shadow-gray-100 bg-white '}
                    transition-color ease-in-out duration-200
                    `}
                    >

                    {active && <TbCircleCheckFilled size={25} className='absolute -right-2 -top-2 bg-white rounded-full text-custom-primary zoomInIconNoDelay' />}

                    <div className='w-full'>
                        <div className='flex items-center gap-2 w-full'>
                            {(add || payCard || icon || image_url) &&
                                <div className='min-w-12 flex justify-center'>
                                    { add && <TbCreditCardPay size={35} />}
                                    { payCard && <TbCreditCard size={35} className={`${active && 'text-shopfood-title'}`} />}
                                    { (!payCard && !add) && icon && icon }
                                    {image_url && 
                                        <Img
                                            src={image_url}
                                            alt={title}
                                            className="max-w-12 max-h-8"
                                            fallback={
                                                <div className='flex items-center justify-center bg-gray-200 max-w-7 min-w-7 max-h-7 min-h-7 rounded-full'>
                                                    <TbPhotoX className='text-white' />
                                                </div>
                                            } 
                                        />
                                    }
                                </div>
                            }
                            <div className={`flex flex-col w-full ${active && 'text-custom-primary'}`}>
                                <div className="grid gap-0.5">
                                <span className="text-xs text-left text-gray-400 leading-none">{ label }</span>
                                <span className={`font-extrabold leading-none text-left`}>{ title }</span>
                                </div>
                            </div>

                            {(number || editButton) &&
                                <div className='flex items-center gap-1.5'>
                                    {number &&
                                        <div className='flex items-center gap-1'>
                                            <Badge className={`font-medium text-xs gap-0.5`}><TbDots /> { number }</Badge>
                                            {main && <Badge outline className={`font-medium text-xs capitalize`}>{t('checkout.button_method_payment_default')}</Badge>}
                                        </div>
                                    }

                                    {editButton &&
                                        <Button rounded onClick={() => {}} className='h-8 w-8'>
                                            <div><TbPencil size={20} /></div>
                                        </Button>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    {children}
                </button>
    )
}

export default ButtonPaymentMethod;